import React, { Fragment, useEffect, useState } from "react";
import { ROUTES } from "../../constants/routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import { getApi } from "../../services/http.service";
import moment from "moment";
import { Icon } from "@iconify/react";
import { ITrip } from "../../interfaces/trip.interface";
import VisibilityBox from "../../components/common/VisibilityBox";
import { totalCases, totalLocationDistance } from "../../utils";
import CustomMapContainer from "../../components/map-container/CustomMapContainer";
import { IDaySale } from "../../interfaces/daysales.interface";

const TripDetail = () => {
  const fUrl = process.env.REACT_APP_FILE_URL;
  const params = useParams();
  const navigate = useNavigate();
  const [trip, setTripDetail] = useState<ITrip>();
  const [sales, setSales] = useState<IDaySale[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchDistributor();
  }, []);

  const fetchDistributor = async () => {
    try {
      const result = await getApi(ROUTES.TRIP_BY_ID + params?.id);
      setTripDetail(result?.data);

      const response = await getApi(ROUTES.SALES_LIST_BY_TRIP, {
        trip: params?.id,
      });
      setSales(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <div>
        <div className="d-flex">
          <button className="nav-link" onClick={() => navigate(-1)}>
            <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
          </button>
          <h4 className="ms-2">Trip Detail</h4>
        </div>
        <section>
          <div className="my-3">
            <div className="table-responsive my-3">
              <table className="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>Trip Plan</th>
                    <td>{trip?.tripPlan}</td>
                    <th>Vehicle Type</th>
                    <td>{trip?.vehicleType || "-"}</td>
                  </tr>
                  <tr>
                    <th>Total Distance</th>
                    <td>{trip?.totalDistance || "-"} KM</td>
                    <th>Total Location Distance</th>
                    <td>{totalLocationDistance(trip?.coordinates || [])} KM</td>
                  </tr>
                  <tr>
                    <th>Plan</th>
                    <td>{trip?.plan || "-"}</td>
                    <th>Status</th>
                    <td>{trip?.endAt ? "Completed" : "Pending"}</td>
                  </tr>
                  {trip?.seniorName && (
                    <tr>
                      <th>Senior Name</th>
                      <td>{trip?.seniorName}</td>
                    </tr>
                  )}
                  {trip?.workingDetail && (
                    <tr>
                      <th>Working Detail</th>
                      <td>{trip?.workingDetail}</td>
                    </tr>
                  )}
                  <tr>
                    <th>Start Reading</th>
                    <td>{trip?.startVehicleReading}</td>
                    <th>End Reading</th>
                    <td>{trip?.endVehicleReading || "-"}</td>
                  </tr>
                  <tr>
                    <th>Starting Address</th>
                    <td>{trip?.startingAddress}</td>
                    <th>Working Area</th>
                    <td>{trip?.workingArea || "-"}</td>
                  </tr>
                  <tr>
                    <th>Ending Address</th>
                    <td>{trip?.endingAddress || "-"}</td>

                    <th>Total Orders</th>
                    <td>{totalCases(trip?.summaries || []) || "-"}</td>
                  </tr>
                  <tr>
                    <th>Start At</th>
                    <td>{moment(trip?.startAt).format("DD MMMM YYYY")}</td>
                    <th>End At</th>
                    <td>{moment(trip?.endAt).format("DD MMMM YYYY")}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <VisibilityBox show={trip?.startVehicleReadingPicture !== ""}>
              <div>
                <label>Trip Starting Image</label>
              </div>
              <img
                src={
                  fUrl +
                  String(
                    trip?.startVehicleReadingPicture || "/images/store.png"
                  )
                }
                style={{ objectFit: "contain", maxWidth: 150 }}
                height={150}
                width={150}
                alt="trip starting vehicle reading"
              />
            </VisibilityBox>
            <VisibilityBox show={trip?.startVehicleReadingPicture !== ""}>
              <div>
                <label>Trip Ending Image</label>
              </div>
              <img
                src={
                  fUrl +
                  String(trip?.endVehicleReadingPicture || "/images/store.png")
                }
                style={{ objectFit: "contain", maxWidth: 150 }}
                height={150}
                width={150}
                alt="trip ending vehicle reading"
              />
            </VisibilityBox>
            <div>
              {trip?.employee && (
                <Link
                  className="nav-link text-primary text-hover-underline"
                  to={`/employees/${trip?.employee}`}
                >
                  View Employee
                </Link>
              )}
            </div>
            <div>
              {trip?.distributor && (
                <Link
                  className="nav-link text-primary text-hover-underline"
                  to={`/distributors/${trip?.distributor}`}
                >
                  View Distributor
                </Link>
              )}
            </div>
          </div>
          <CustomMapContainer
            coordinates={trip?.coordinates || []}
            sales={sales}
          />
        </section>
      </div>
    </>
  );
};

export default TripDetail;
